<template>
    <div class="svg-circle-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
            <circle cx="3" cy="3" r="3" fill="#666666" />
        </svg>
    </div>
</template>

<style lang="less" scoped>
    .svg-circle-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
